import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class FinanceAPGoodsReceiveNoteActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Accounting/GoodsReceiveNote/GoodsReceiveNoteBrowser")
	}

	render() {
		return (
			<Activity 
				name="FinanceAPGoodsReceiveNote"
				RenderedComponent={this.RenderedComponent}
				context="FinanceAPGoodsReceiveNote"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(FinanceAPGoodsReceiveNoteActivity)
